import React, { Component } from "react";
import Api from "../../Components/Api";
import LoginForm from "../../Components/LoginForm";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import LanguageLoginSelect from "../../Components/LanguageLoginSelect";
import __ from "../../Components/Language";

UIkit.use(Icons);

export default class MemberLogin extends Component {
  state = {
    verifyEmail: false,
    email: "",
    otp: "",
    token: "",
    session: "",
    otpLoading: false,
    resendCountdown: 60,
    resendInterval: null,
  };

  componentDidMount() {
    if (this.state.verifyEmail) {
      this.startResendCountdown();
    }
  }

  componentWillUnmount() {
    if (this.state.resendInterval) clearInterval(this.state.resendInterval);
  }

  handleRedirect = (session) => {
    localStorage.setItem("memberLogin", session);
    if (this.props.qs.redirect) {
      window.location.href = `${decodeURIComponent(this.props.qs.redirect)}?route=${decodeURIComponent(this.props.qs.redirect)}&token_member=${encodeURIComponent(session)}`;
    } else if (this.props.qs.menu === "record") {
      window.location.href = `https://smarthealth-line.dietz.asia/data?route=${encodeURIComponent(`/data?redirect=${encodeURIComponent("https://smarthealth.dietz.asia/user-smart-health")}`)}&token_member=${encodeURIComponent(session)}`;
    } else if (this.props.qs.menu === "risk") {
      window.location.href = "/user-smart-health#d-smarth-health-trending-graph";
    } else if (this.props.qs.menu === "display") {
      window.location.href = `https://liff.line.me/2006538121-y9BkoYb3?token_member=${encodeURIComponent(session)}`;
    } else {
      window.location.reload();
    }
  };

  sendOtpEmail = async (email) => {
    const res = await fetch("https://servermail.dietz.asia", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "send", email }),
    });
    const { token } = await res.json();
    return token;
  };

  startResendCountdown = () => {
    if (this.state.resendInterval) clearInterval(this.state.resendInterval);
    let count = 60;
    this.setState({ resendCountdown: count, resendInterval: null });
    const interval = setInterval(() => {
      count -= 1;
      if (count <= 0) {
        clearInterval(interval);
        this.setState({ resendCountdown: 0, resendInterval: null });
      } else {
        this.setState({ resendCountdown: count });
      }
    }, 1000);
    this.setState({ resendInterval: interval });
  };

  login = async (data) => {
    if (!data.cf_token) {
      UIkit.notification(
        `<span uk-icon='icon: close'></span> ${__("โปรดยืนยันว่าคุณเป็นมนุษย์")}`,
      );
      return;
    }

    var { result, responseText, session, isVerifyEmail, email } = await Api.member(
      "MemberLoginByForm2",
      data,
    );

    if (isVerifyEmail === true) {
      const token = await this.sendOtpEmail(email);
      this.setState({ verifyEmail: true, email, token, session }, () => {
        this.startResendCountdown();
      });
    } else {
      UIkit.notification(
        `<span uk-icon='icon: ${result ? "check" : "close"}'></span> ${__(responseText)}`,
      );
      if (result && session) this.handleRedirect(session);
    }
  };

  resendOtp = async () => {
    if (this.state.resendCountdown > 0) return;
    const token = await this.sendOtpEmail(this.state.email);
    if (token) {
      this.setState({ token });
      this.startResendCountdown();
    } else {
      UIkit.notification(`<span uk-icon='icon: close'></span> ${__("เกิดข้อผิดพลาดในการขอ OTP")}`);
    }
  };

  submitOtp = async (e) => {
    e.preventDefault();
    const { otp, token } = this.state;
    if (!otp) {
      UIkit.notification(`<span uk-icon='icon: close'></span> ${__("โปรดใส่รหัส OTP")}`);
      return;
    }

    this.setState({ otpLoading: true });
    try {
      const res = await fetch("https://servermail.dietz.asia", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "verify", token, otp }),
      });
      var { result, responseText } = await res.json();

      UIkit.notification(
        `<span uk-icon='icon: ${result ? "check" : "close"}'></span> ${__(responseText)}`,
      );
      if (result) this.handleRedirect(this.state.session);
    } finally {
      this.setState({ otpLoading: false });
    }
  };

  backToLogin = () => {
    if (this.state.resendInterval) clearInterval(this.state.resendInterval);
    this.setState({ verifyEmail: false, email: "", otp: "", token: "", resendCountdown: 60, resendInterval: null });
  };

  renderOtpForm() {
    const { otp, resendCountdown, otpLoading } = this.state;
    return (
      <form onSubmit={this.submitOtp} className="uk-margin-top uk-text-center">
        <div style={{ fontSize: 64, color: "#29ABE2" }}>
          <span uk-icon="icon: mail; ratio: 3"></span>
        </div>
        <p className="uk-margin-small-top">
          {__("กรุณาใส่รหัส OTP ที่ส่งไปยังอีเมลของท่าน")}<br />
          {__("ที่ได้ลงทะเบียนเพื่อยืนยันตัวตน")}
        </p>
        <input
          className="uk-input uk-margin-small-top text-center"
          type="text"
          value={otp}
          onChange={(e) => this.setState({ otp: e.target.value })}
          placeholder=""
          maxLength={6}
        />
        <button
          className="uk-button uk-button-primary uk-width-1-1 uk-margin-small-top"
          type="submit"
          disabled={otpLoading}
        >
          {otpLoading ? <span uk-spinner="ratio: 0.7"></span> : __("เข้าสู่ระบบ")}
        </button>
        <div className="uk-margin-small-top uk-text-small">
          {__("หากไม่ได้รับรหัส OTP ให้ส่งใหม่อีกครั้ง")}
        </div>
        <div className="uk-margin-small-top">
          {resendCountdown > 0 ? (
            <span style={{ color: "#29ABE2" }}>
              {__("ขอรหัสใหม่")} ({resendCountdown})
            </span>
          ) : (
            <a onClick={this.resendOtp} style={{ color: "#29ABE2", cursor: "pointer" }}>
              {__("ขอรหัสใหม่")}
            </a>
          )}
        </div>
        <div className="uk-margin-top">
          <a onClick={this.backToLogin} style={{ cursor: "pointer" }}>
            ← {__("กลับหน้าเข้าสู่ระบบ")}
          </a>
        </div>
      </form>
    );
  }

  render() {
    return (
      <div>
        <div className="d-form-login-body uk-padding-small">
          <div className="uk-card uk-card-default uk-padding uk-margin-top uk-padding-remove-top d-form-login-container">
            <LanguageLoginSelect />
            <div className="uk-text-center uk-padding-small">
              <img src="/logo_dietz.png" />
            </div>
            <h1 className="d-form-login-title">{__("เข้าสู่ระบบ")}</h1>
            {this.state.verifyEmail ? (
              this.renderOtpForm()
            ) : (
              <LoginForm {...this.props} onSubmit={this.login} />
            )}
          </div>
        </div>
      </div>
    );
  }
}
